import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core'
import { DatePipe } from '@angular/common'
import { OrderTrackingService } from '../order-tracking.service'
import { Router } from '@angular/router'
import { saveAs } from 'file-saver'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { Observable } from 'rxjs'
import { StatusTile } from '../../../shared/components/status-tiles/status-tiles.component'
import { StatusType } from '../../../models/status/status.model'
import {
  DateFormats,
  DateRange,
} from '../../../shared/components/date-range-picker/date-range-picker.component'
import { BreadcrumbService } from '../../../shared/components/breadcrumb/breadcrumb.service'
import { CommonService } from '../../../shared/services/common.service'
import { OrderStatusTypes } from '../../../models/status/order-status.model'

const PAGE_SIZE = 50

@Component({
  standalone: false,
  selector: 'app-order-tracking-list',
  templateUrl: './order-tracking-list.component.html',
  styleUrls: ['./order-tracking-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrderTrackingListComponent implements OnInit {
  public toMinDate
  public fromMaxDate
  public changeDate: boolean = false
  //public refreshDate:boolean=false;
  public fromMax
  public fromStartDate
  public noData
  public tableData
  public createdby
  public dataSource = []
  quoteTiles: StatusTile[]
  firstStatusType: StatusType
  fromDate: DateFormats = new DateFormats()
  toDate: DateFormats = new DateFormats()
  public dateRange: boolean
  public searchcreatedby: boolean
  searchTerm = ''
  displayValue = ''
  currentUser: any
  isRefreshedFlag: boolean
  selectedCreated
  displayedColumns = [
    'Order',
    'Order Status',
    'PO Number',

    'PO Date',
    'Net Price',
    'Order Created',
    'Last Updated',
  ]
  statusFilter = ''
  statusFilterTxt: any = ''
  currentPage = 0
  isLoadMoreInProgress = false
  full: boolean = true
  sortBy = 'OrderDsc'
  searchFieldUpdated: boolean = false
  totalPages: any
  totalOrders_excel: any
  getMonths$: Observable<any>
  monthDifference: number = 6
  currency: any

  constructor(
    private breadCrumbService: BreadcrumbService,
    public datepipe: DatePipe,
    public orderTrackingService: OrderTrackingService,
    private commonService: CommonService,
    public router: Router,
    private cRef: ChangeDetectorRef,
    private translate: TranslationService,
    protected globalMessageService: GlobalMessageService
  ) {
    this.dateRange = false
    this.quoteTiles = [
      {
        orderStatus: OrderStatusTypes.TOTAL,
        statusType: StatusType.ORDER,
      },
      {
        orderStatus: OrderStatusTypes.PROGRESS,
        statusType: StatusType.ORDER,
        colorTheme: 'pending',
        tooltip:
          'We have assigned a ship date to all of your line items. Some line items may have moved further, but at least one item is not yet shipped.',
      },
      {
        orderStatus: OrderStatusTypes.BLOCKED,
        statusType: StatusType.ORDER,
        colorTheme: 'order-blocked',
        tooltip:
          'We need some information from you. The order is blocked, and the order cannot move forwardwithout this information. Please contact your Customer Care team.',
      },
      {
        orderStatus: OrderStatusTypes.SHIPPED,
        statusType: StatusType.ORDER,
        colorTheme: 'closed',
        tooltip:
          'All line items have been shipped, but not all items have been invoiced.',
      },
      {
        orderStatus: OrderStatusTypes.INVOICED,
        statusType: StatusType.ORDER,
        colorTheme: 'order-invoiced',
        tooltip: 'All line items have been shipped and invoiced.',
      },
    ]
    this.isRefreshedFlag
    this.getMonths$ = this.orderTrackingService.getConfigMonth()
    this.getMonths$.subscribe((success: any) => {
      this.monthDifference = parseInt(success)
      this.fromMax = new Date()
      this.fromMaxDate = new Date()
      this.fromMaxDate = this.fromMax.setMonth(
        this.fromMax.getMonth() - this.monthDifference
      )
      this.fromStartDate = this.fromMaxDate
      this.toMinDate = new Date()
      this.cRef.detectChanges()
      this.orderTrackingService.emitTileStatus.next('All Orders')
      this.dataSource = []
      this.commonService.getUserData().subscribe(
        (user) => {
          if (user) {
            this.currentUser = user
            if (!this.dataSource.length && !this.isLoadMoreInProgress) {
              this.loadOrders()
              this.loadOrdersdropdown()
            }
          } else {
            this.dataSource = []
          }
        },
        (err) => {}
      )
    })
  }

  ngOnInit(): void {
    this.currency = sessionStorage.getItem('currency')
    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('orderTracking.myOrders')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )
    this.firstStatusType = StatusType.ORDER
    //this.loadOrdersdropdown();
  }

  loadOrdersdropdown() {
    this.isLoadMoreInProgress = true
    //this.isFromLoadMore = false;
    this.noData = false
    const formattedFromDate = this.datepipe.transform(
      this.fromStartDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )
    this.currentPage = 0
    this.orderTrackingService
      .getOrders(
        this.currentUser.uid,
        this.searchTerm,
        this.statusFilter,
        this.dateRange,
        formattedFromDate,
        formattedToDate,
        this.currentPage,
        PAGE_SIZE,
        this.sortBy
      )
      .subscribe(
        (res: any) => {
          this.createdby = res
        },
        (error) => {
          this.isLoadMoreInProgress = false
          this.globalMessageService.add(
            { key: 'orderTracking.issueWhileLoadingOrder' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  loadOrders() {
    this.isLoadMoreInProgress = true
    //this.isFromLoadMore = false;
    this.noData = false
    if(this.searchTerm){
       this.selectedCreated = null;
       this.searchcreatedby = false
    }
    const formattedFromDate = this.datepipe.transform(
      this.fromStartDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )
    this.currentPage = 0

    this.orderTrackingService
      .getOrders(
        this.currentUser.uid,
        this.searchTerm.trim(),
        this.statusFilter,
        this.dateRange,
        formattedFromDate,
        formattedToDate,
        this.currentPage,
        PAGE_SIZE,
        this.sortBy
      )
      .subscribe(
        (res: any) => {
          this.tableData = res
          this.dataSource = res.ordersList
          // this.selectedCreated = this.tableData.createdByList;
          if (res.pagination !== undefined) {
            this.currentPage = res.pagination.currentPage
            this.totalPages = res.pagination.totalPages
            this.totalOrders_excel = res.pagination.totalResults
          } else {
            this.currentPage = 0
            this.totalPages = 0
            this.totalOrders_excel = 0
          }
          if (res.ordersList.length > 0) {
            // this.dataSource = [
            //   ...this.dataSource.sort(
            // (a, b) => 0 - (a.purchaseOrderDate > b.purchaseOrderDate ? 1 : -1)
            // ),];
            const data = res.orderStatus
            this.quoteTiles = [
              {
                orderStatus: OrderStatusTypes.TOTAL,
                statusType: StatusType.ORDER,
                statusCount: data.totalProductCount,
              },
              // {
              //   orderStatus: OrderStatusTypes.SUBMITTED,
              //   statusType: StatusType.ORDER,
              //   colorTheme: 'progress',
              //   statusCount: data.count,
              // },
              {
                orderStatus: OrderStatusTypes.PROGRESS,
                statusType: StatusType.ORDER,
                colorTheme: 'pending',
                statusCount: data.processingCount,
                tooltip:
                  'We have assigned a ship date to all of your line items. Some line items may have moved further, but at least one item is not yet shipped.',
              },
              {
                orderStatus: OrderStatusTypes.BLOCKED,
                statusType: StatusType.ORDER,
                colorTheme: 'order-blocked',
                statusCount: data.blockCount,
                tooltip:
                  'We need some information from you. The order is blocked, and the order cannot move forwardwithout this information. Please contact your Customer Care team.',
              },
              {
                orderStatus: OrderStatusTypes.SHIPPED,
                statusType: StatusType.ORDER,
                colorTheme: 'closed',
                statusCount: data.awaitingCount,
                tooltip:
                  'All line items have been shipped, but not all items have been invoiced.',
              },
              {
                orderStatus: OrderStatusTypes.INVOICED,
                statusType: StatusType.ORDER,
                colorTheme: 'order-invoiced',
                statusCount: data.shippedCount,
                tooltip: 'All line items have been shipped and invoiced.',
              },
            ]
            this.isLoadMoreInProgress = false
          } else {
            this.noData = true
            this.isLoadMoreInProgress = false
          }
        },
        (error) => {
          this.isLoadMoreInProgress = false
          this.globalMessageService.add(
            { key: 'orderTracking.issueWhileLoadingOrder' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  currentlyLoading: boolean = false

  loadMoreOrders() {
    if(this.selectedCreated){
      this.displayValue = this.selectedCreated;
    }else{
      this.displayValue = this.searchTerm;
    }
    // on reaching bottom load previous 6 month order
    if (this.isLoadMoreInProgress) {
      return
    }
    if (this.currentlyLoading) {
      return
    }
    //this.isLoadMoreInProgress = true;
    this.currentlyLoading = true
    const formattedFromDate = this.datepipe.transform(
      this.fromStartDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )

    let crntPage = this.currentPage
    crntPage++
    if (crntPage <= this.totalPages - 1) {
      //check if current page is equal to the last page then dnt make a call
      this.orderTrackingService
        .getOrders(
          this.currentUser.uid,
          this.displayValue,
          this.statusFilter,
          this.dateRange,
          formattedFromDate,
          formattedToDate,
          crntPage,
          PAGE_SIZE,
          this.sortBy
        )
        .subscribe(
          (res: any) => {
            if (res !== null && res !== undefined) {
              this.isLoadMoreInProgress = false
              if (res.pagination !== undefined) {
                this.currentPage = res.pagination.currentPage
                this.totalPages = res.pagination.totalPages
                this.totalOrders_excel = res.pagination.totalResults
              } else {
                this.currentPage = 0
                this.totalPages = 0
                this.totalOrders_excel = 0
              }

              if (res.ordersList && res.ordersList.length) {
                this.dataSource = this.dataSource.concat(res.ordersList)
              }
              this.currentlyLoading = false
            } else {
              this.isLoadMoreInProgress = false
              this.currentlyLoading = false
              this.globalMessageService.add(
                { key: 'orderTracking.issueWhileLoadingOrderList' },
                GlobalMessageType.MSG_TYPE_ERROR,
                5000
              )
              window.scrollTo(0, 0)
            }
          },
          (err) => {
            this.isLoadMoreInProgress = false
            this.currentlyLoading = false
            this.globalMessageService.add(
              { key: 'orderTracking.issueWhileLoadingOrderList' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    } else {
      this.isLoadMoreInProgress = false
      this.currentlyLoading = false
    }
  }

  selectedOrder(element) {
    // this.router.navigate(["/order-tracking/detail",element]);
    const formattedFromDate = this.datepipe.transform(
      this.fromStartDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )
    const dateObject = {
      fromDate: formattedFromDate,
      toDate: formattedToDate,
    }
    this.router.navigate(['/order-detail/detail/' + element], {
      queryParams: dateObject,
    })
  }
  onTileClick(e: StatusTile) {
    if (e.orderStatus.statusIndex === OrderStatusTypes.BLOCKED.statusIndex) {
      this.statusFilter = 'Blocked'
      this.statusFilterTxt = 'Blocked'
      this.orderTrackingService.emitTileStatus.next('Blocked')
    } else if (
      e.orderStatus.statusIndex === OrderStatusTypes.PROGRESS.statusIndex
    ) {
      this.statusFilter = 'Processing'
      this.statusFilterTxt = 'Order In Progress'
      this.orderTrackingService.emitTileStatus.next('Order In Progress')
    } else if (
      e.orderStatus.statusIndex === OrderStatusTypes.SHIPPED.statusIndex
    ) {
      this.statusFilter = 'Shipped'
      this.statusFilterTxt = 'Shipped'
      this.orderTrackingService.emitTileStatus.next('Shipped')
    } else if (
      e.orderStatus.statusIndex === OrderStatusTypes.INVOICED.statusIndex
    ) {
      this.statusFilter = 'Shipped %26 Invoiced'
      this.statusFilterTxt = 'Shipped & Invoiced'
      this.orderTrackingService.emitTileStatus.next('Shipped & Invoiced')
    }
    // else if (
    //   e.orderStatus.statusIndex === OrderStatusTypes.SUBMITTED.statusIndex
    // ) {
    //   this.statusFilter = 'Received';
    //   this.statusFilterTxt = 'Received';
    //   this.orderTrackingService.emitTileStatus.next('Received');
    // }
    else {
      this.statusFilter = ''
      this.statusFilterTxt = ''
      this.orderTrackingService.emitTileStatus.next('All Orders')
    }
    this.loadOrders()
  }

  getDateRange(e: DateRange) {
    this.fromDate = e.from
    this.toDate = e.to
    this.fromStartDate = this.fromDate.date
    if (this.toDate < this.fromDate) {
      this.dateRange = false
    } else {
      this.dateRange = true
      this.loadOrders()
    }
  }

  clearDateRange() {
    this.changeDate = true
    //this.refreshDate=true;
    this.fromMax = new Date()
    this.fromMaxDate = this.fromMax.setMonth(
      this.fromMax.getMonth() - this.monthDifference
    )
    this.fromStartDate = this.fromMaxDate
    this.toMinDate = new Date()

    this.fromDate = new DateFormats()
    this.toDate = new DateFormats()
    // document.querySelector('label .date-range-text').innerHTML =
    //   'Select date range';
    this.dateRange = false
    // this.refreshDate=false;
    this.loadOrders()
  }
  getClearDate(clearDate) {
    this.changeDate = false
  }

  clearSearchTerm() {
    this.searchTerm = ''
    this.searchFieldUpdated = false
    this.loadOrders()
  }
  clearStatus() {
    this.statusFilter = ''
    this.statusFilterTxt = ''
    this.loadOrders()
    this.orderTrackingService.emitTileStatus.next('All Orders')
  }
  clearAll() {
    this.searchTerm = ''
    this.statusFilter = ''
    this.statusFilterTxt = ''
    this.searchFieldUpdated = false
    this.searchcreatedby = false
    this.selectedCreated = null
    this.sortBy = null
    this.clearDateRange()
    this.orderTrackingService.emitTileStatus.next('All Orders')
  }
  clearcreatedbyFilter() {
    this.searchTerm = ''
    this.searchFieldUpdated = false
    this.selectedCreated = null
    this.searchcreatedby = false
    this.changeDate = false
    this.loadOrders()
  }
  modelChange() {
    if (this.searchTerm.trim().length > 0) {
      this.searchFieldUpdated = true
      this.loadOrders()
    }
  }

  searchTermChanged() {
    this.searchFieldUpdated = false
    this.statusFilter = ''
  }
  decreasing(sortByDsc) {
    this.sortBy = sortByDsc
    this.loadOrders()
  }

  increasing(sortByAsc) {
    this.sortBy = sortByAsc
    this.loadOrders()
  }

  displayStatus(statusCode) {
    if (statusCode === 'Received') {
      return 'Order Received'
    }
    if (statusCode === 'Processing') {
      return 'Order In Progress'
    }
    return statusCode
  }

  downloadXLS() {
    const formattedFromDate = this.datepipe.transform(
      this.fromStartDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )
    this.orderTrackingService
      .getDetailsinXLSFormat(
        this.currentUser.uid,
        this.searchTerm,
        this.statusFilter,
        this.dateRange,
        formattedFromDate,
        formattedToDate,
        this.currentPage,
        this.totalOrders_excel
      )
      .subscribe(
        (res) => {
          if (res !== null && res !== undefined) {
            const currentDate = this.datepipe.transform(
              new Date(),
              'dd-MM-yyyy'
            )
            let fileName = 'MyOrders_' + currentDate
            const blob = new Blob([res], { type: 'application/vnd.ms.excel' })
            const file = new File([blob], fileName + '.xlsx', {
              type: 'application/vnd.ms.excel',
            })
            saveAs(file)
          } else {
            this.displayDownloadError()
          }
        },
        (error) => {
          this.displayDownloadError()
        }
      )
  }

  displayDownloadError() {
    this.globalMessageService.add(
      { key: 'orderTracking.issueWhileDownloadingXls' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }

  displaySearchTerm(searchTerm) {
    if (searchTerm.trim().length > 3) {
      return searchTerm.substring(0, 5) + '...'
    }
    return searchTerm
  }

  refreshList() {
    this.isRefreshedFlag = true
    this.isLoadMoreInProgress = true
    this.noData = false
    const formattedFromDate = this.datepipe.transform(
      this.fromStartDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )
    this.currentPage = 0

    this.orderTrackingService
      .getRefreshOrders(
        this.currentUser.uid,
        this.searchTerm,
        this.statusFilter,
        this.dateRange,
        formattedFromDate,
        formattedToDate,
        this.currentPage,
        PAGE_SIZE,
        this.sortBy,
        this.isRefreshedFlag
      )
      .subscribe(
        (res: any) => {
          this.tableData = res
          this.dataSource = res.ordersList
          if (res.pagination !== undefined) {
            this.currentPage = res.pagination.currentPage
            this.totalPages = res.pagination.totalPages
          } else {
            this.currentPage = 0
            this.totalPages = 0
          }
          if (res.ordersList.length > 0) {
            // this.dataSource = [
            //   ...this.dataSource.sort(
            // (a, b) => 0 - (a.purchaseOrderDate > b.purchaseOrderDate ? 1 : -1)
            // ),];
            const data = res.orderStatus
            this.quoteTiles = [
              {
                orderStatus: OrderStatusTypes.TOTAL,
                statusType: StatusType.ORDER,
                statusCount: data.totalProductCount,
              },
              // {
              //   orderStatus: OrderStatusTypes.SUBMITTED,
              //   statusType: StatusType.ORDER,
              //   colorTheme: 'progress',
              //   statusCount: data.count,
              // },
              {
                orderStatus: OrderStatusTypes.PROGRESS,
                statusType: StatusType.ORDER,
                colorTheme: 'pending',
                statusCount: data.processingCount,
                tooltip:
                  'We have assigned a ship date to all of your line items. Some line items may have moved further, but at least one item is not yet shipped.',
              },
              {
                orderStatus: OrderStatusTypes.BLOCKED,
                statusType: StatusType.ORDER,
                colorTheme: 'returned',
                statusCount: data.blockCount,
                tooltip:
                  'We need some information from you. The order is blocked, and the order cannot move forwardwithout this information. Please contact your Customer Care team.',
              },
              {
                orderStatus: OrderStatusTypes.SHIPPED,
                statusType: StatusType.ORDER,
                colorTheme: 'closed',
                statusCount: data.awaitingCount,
                tooltip:
                  'All line items have been shipped, but not all items have been invoiced.',
              },
              {
                orderStatus: OrderStatusTypes.INVOICED,
                statusType: StatusType.ORDER,
                colorTheme: 'expired',
                statusCount: data.shippedCount,
                tooltip: 'All line items have been shipped and invoiced.',
              },
            ]
            this.isLoadMoreInProgress = false
          } else {
            this.noData = true
            this.isLoadMoreInProgress = false
          }
        },
        (error) => {
          this.isLoadMoreInProgress = false
          this.globalMessageService.add(
            { key: 'orderTracking.issueWhileLoadingOrder' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  decrease() {
    this.dataSource = [
      ...this.dataSource.sort(
        (a, b) =>
          0 - (a.createdBy.toLowerCase() > b.createdBy.toLowerCase() ? 1 : -1)
      ),
    ]
  }
  increase() {
    this.dataSource = [
      ...this.dataSource.sort(
        (a, b) =>
          0 - (a.createdBy.toLowerCase() < b.createdBy.toLowerCase() ? 1 : -1)
      ),
    ]
  }
  getselectedCreatedby(val) {
    this.selectedCreated = val
    this.statusFilterTxt = false
    this.dateRange = false
    this.searchFieldUpdated = false
    this.searchcreatedby = true
    this.searchTerm = '';
    //this.searchTerm  = this.selectedCreated;
    this.isLoadMoreInProgress = true
    //this.isFromLoadMore = false;
    this.noData = false
    const formattedFromDate = this.datepipe.transform(
      this.fromStartDate,
      'yyyy-MM-dd'
    )
    const formattedToDate = this.datepipe.transform(
      this.toDate.date,
      'yyyy-MM-dd'
    )
    this.currentPage = 0

    this.orderTrackingService
      .getOrders(
        this.currentUser.uid,
        //this.searchTerm,
        this.selectedCreated,
        this.statusFilter,
        this.dateRange,
        formattedFromDate,
        formattedToDate,
        this.currentPage,
        PAGE_SIZE,
        this.sortBy
      )
      .subscribe(
        (res: any) => {
          this.tableData = res
          this.dataSource = res.ordersList
          // this.selectedCreated = this.tableData.createdByList;
          if (res.pagination !== undefined) {
            this.currentPage = res.pagination.currentPage
            this.totalPages = res.pagination.totalPages
            this.totalOrders_excel = res.pagination.totalResults
          } else {
            this.currentPage = 0
            this.totalPages = 0
            this.totalOrders_excel = 0
          }
          if (res.ordersList.length > 0) {
            // this.dataSource = [
            //   ...this.dataSource.sort(
            // (a, b) => 0 - (a.purchaseOrderDate > b.purchaseOrderDate ? 1 : -1)
            // ),];
            const data = res.orderStatus
            this.quoteTiles = [
              {
                orderStatus: OrderStatusTypes.TOTAL,
                statusType: StatusType.ORDER,
                statusCount: data.totalProductCount,
              },
              // {
              //   orderStatus: OrderStatusTypes.SUBMITTED,
              //   statusType: StatusType.ORDER,
              //   colorTheme: 'progress',
              //   statusCount: data.count,
              // },
              {
                orderStatus: OrderStatusTypes.PROGRESS,
                statusType: StatusType.ORDER,
                colorTheme: 'pending',
                statusCount: data.processingCount,
                tooltip:
                  'We have assigned a ship date to all of your line items. Some line items may have moved further, but at least one item is not yet shipped.',
              },
              {
                orderStatus: OrderStatusTypes.BLOCKED,
                statusType: StatusType.ORDER,
                colorTheme: 'order-blocked',
                statusCount: data.blockCount,
                tooltip:
                  'We need some information from you. The order is blocked, and the order cannot move forwardwithout this information. Please contact your Customer Care team.',
              },
              {
                orderStatus: OrderStatusTypes.SHIPPED,
                statusType: StatusType.ORDER,
                colorTheme: 'closed',
                statusCount: data.awaitingCount,
                tooltip:
                  'All line items have been shipped, but not all items have been invoiced.',
              },
              {
                orderStatus: OrderStatusTypes.INVOICED,
                statusType: StatusType.ORDER,
                colorTheme: 'order-invoiced',
                statusCount: data.shippedCount,
                tooltip: 'All line items have been shipped and invoiced.',
              },
            ]
            this.isLoadMoreInProgress = false
          } else {
            this.noData = true
            this.isLoadMoreInProgress = false
          }
        },
        (error) => {
          this.isLoadMoreInProgress = false
          this.globalMessageService.add(
            { key: 'orderTracking.issueWhileLoadingOrderList' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  getNetPrice(netPrice, jpyCurrency) {
    if (jpyCurrency.indexOf('JPY') != -1) {
      netPrice = netPrice.split('.')
      return netPrice[0]
    } else {
      return parseFloat(netPrice.replace(/,/g, '')).toFixed(2)
    }
  }
}
